export enum MergeModelEnum {
  'Task' = 1,
  'Job',
  'Order',
  'Customer',
  'Vehicle',
  'TaskStep',
  'Organisation',
  'Driver',
  'UserRequest',
  'User',
  'JobWatched',
  'AdditionalCharge',
  'DelayFailure',
  'OrderCancellationRequest',
  'CustomerInvoice',
  'UserAccountNotification' = 16,
  'OrderQuote',
  'DriverMessage' = 19,
  'BankAccount' = 20,
  'RouteRecommendation' = 21,
}

export const MergeModelName = {
  1: 'Task',
  2: 'Job',
  3: 'Order',
  4: 'Customer',
  5: 'Vehicle',
  6: 'TaskStep',
  7: 'Organisation',
  8: 'Driver',
  9: 'UserRequest',
  10: 'User',
  11: 'JobWatched',
  12: 'AdditionalCharge',
  13: 'DelayFailure',
  14: 'OrderCancellationRequest',
  15: 'CustomerInvoice',
  16: 'UserAccountNotification',
  17: 'OrderQuote',
  18: 'InvoiceAddress',
  19: 'DriverMessage',
  20: 'BankAccount',
  21: 'RouteRecommendation',
};
